import Cookies from "js-cookie";
import Vue from "vue";
import {
    LOGOUT,
    LOGIN, 
} from "./types";

export const doLogin = (context, data) => {
    return Vue.$rest.executeRequest(context,LOGIN, "att/login", data, "post")
        .then(response => {
            if (response.data.token) {
                Cookies.set(Vue.$constants.SESSION_COOKIE, response.data.token, "30MIN");
            }
        })
        .catch(error => {
            return Promise.reject(error);
        });
};

export const logout = ({ commit }) => {
    Cookies.remove(Vue.$constants.SESSION_COOKIE);
    commit(LOGOUT);
    return Promise.resolve();
};

